module.exports = __webpack_public_path__ + "static/img/platform_ttl.f81d051.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/platform_ttl.svg
// module id = kdM3
// module chunks = 0